import React from 'react';

import { useAppContext } from '@contexts/AppContext';
import useServerSideRendering from '@hooks/useServerSideRendering';
import { topic_landing_path } from '@routes';
import { getImgxSrc } from '@utils/images';

import { EventProp } from './TimeLine';

const ARTICLE_STYLES = 'w-full border-0 border-b-2 border-solid h-[200px] relative border-gray-200';
const ARTICLE_STYLES_BEFORE = `before:content-[''] before:absolute before:h-10
  before:left-[calc(10.5%_+_117px)] before:right-[274px] before:bottom-0
  before:bg-[repeating-linear-gradient(to_right,#fff,#fff_11%,#f2f2f2_11%,#f2f2f2_11.5%)]`;

const HorizontalTimePoint = ({ events }: { events: EventProp[] }) => {
  const { env } = useAppContext();
  const hydrated = useServerSideRendering();
  const firstEvent = events[0];
  const secondEvent = events[1];

  return (
    <article className={`${ARTICLE_STYLES} ${ARTICLE_STYLES_BEFORE}`}>
      <a
        className="topic-badge track-link absolute bottom-10 left-0"
        data-type="link"
        data-name={`topic badge: ${firstEvent.topic}`}
        data-location="brand_campaign#index"
        href={topic_landing_path({ topic: firstEvent.topic })}
      >
        {firstEvent.topic}
      </a>
      <div className="absolute left-0 top-0 ml-[10.5%] h-full w-[420px]">
        {hydrated && (
          <img
            className="absolute left-0 max-w-[265px]"
            src={getImgxSrc({
              path: firstEvent.logoPath,
              isDevDependence: true,
              envContext: env,
            })}
            alt="TI Time Line"
          />
        )}
        <div className="absolute left-[27.9%] top-[4rem] w-full max-w-[260px]">
          <a
            className="text-left font-serif text-button-lg leading-6 tracking-normal underline sm:text-[22px] sm:leading-8"
            href={firstEvent.articleLink}
          >
            “{firstEvent.articleTitle}”
          </a>
        </div>
        {hydrated && (
          <img
            className="absolute left-[22.6%] top-72"
            src={getImgxSrc({
              path: 'brand_campaign/pinRed.svg',
              isDevDependence: true,
              envContext: env,
            })}
            alt="TI Time Line"
          />
        )}
        <div className="absolute -bottom-48 left-0 w-1/2 text-center font-sans text-overline uppercase text-pro-red">
          {firstEvent.month} {firstEvent.year}
        </div>
      </div>

      <div className="absolute right-0 top-0 h-full w-[340px]">
        {hydrated && (
          <img
            className="absolute left-0 top-[1rem] max-w-[150px]"
            src={getImgxSrc({
              path: secondEvent.logoPath,
              isDevDependence: true,
              envContext: env,
            })}
            alt="TI Time Line"
          />
        )}
        <div className="absolute left-[26.5%] top-[4rem] w-full max-w-[260px] font-serif text-[16px] leading-6 sm:leading-6">
          “{secondEvent.articleTitle}”
        </div>
        {hydrated && (
          <img
            className="absolute left-[19.4%] top-72"
            src={getImgxSrc({
              path: 'brand_campaign/pinGray.svg',
              isDevDependence: true,
              envContext: env,
            })}
            alt="TI Time Line"
          />
        )}
        <div className="absolute -bottom-48 w-[47.1%] text-center font-sans text-overline uppercase">
          {secondEvent.month} {secondEvent.year}
        </div>
      </div>
    </article>
  );
};

export default HorizontalTimePoint;
